<template>
  <ul class="w-category-list">
    <li v-for="item in categoryList" :key="item?.code">
      <a href="#" class="category-item" @click.prevent="onClickItem(item)">
        {{ item.text }}
      </a>
    </li>
  </ul>
</template>

<script setup>
  const emit = defineEmits(['click'])

  const props = defineProps({
    categoryList: {
      type: Array,
      default: () => [],
    },
  })
  const onClickItem = (item) => {
    emit('click', item)
  }
</script>

<style lang="scss" scoped>
  .w-category-list {
    display: grid;
    flex-wrap: nowrap;
    grid-auto-flow: column;
    justify-content: start;
    gap: 20px;
    padding: 0 12px;
    overflow-x: auto;
    .category-item {
      font-size: 16px;
      line-height: 24px;
      color: #a5a5a5;
      white-space: nowrap;
    }
  }
</style>
